'use strict';

var _detachedApplication = require('./detached-application');

var _detachedApplication2 = _interopRequireDefault(_detachedApplication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

require('intl'); // needed for react intl otherwise stuff busts

module.exports = _detachedApplication2['default'];

// All HelloSign components need to be attached to the application for legacy
// purposes.
_detachedApplication2['default'].components = require('./components');
_detachedApplication2['default'].mixins = {
    'AdjustScrollingMixin': require('./components/api-docs/api-menu/adjust-scrolling-mixin')
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/application.js
 ** module id = 487
 ** module chunks = 0
 **/